<script setup lang="ts">
  import { ref, useCssModule } from 'vue';

  import Icon from '../Icon/Icon.vue';

  export interface CardMediaProps {
    /**
     * The image source.
     */
    src: string;
    /**
     * The image alternative text.
     */
    alt?: string;
  }

  const isLoading = ref(true);

  const hasErrored = ref(false);

  const props = defineProps<CardMediaProps>();

  const classes = useCssModule();
</script>

<template>
  <div class="stash-card-media" data-test="stash-card-media">
    <div
      v-if="isLoading || hasErrored"
      :class="classes.placeholder"
      class="flex w-full items-center justify-center rounded-t bg-ice-200"
    >
      <Icon name="image" :class="classes.iconSize" />
    </div>
    <img
      :src="props.src"
      class="w-full rounded-t"
      :alt="props.alt"
      @load="() => (isLoading = false)"
      @error="() => (hasErrored = true)"
    />
  </div>
</template>

<style module>
  .placeholder {
    height: 300px;
    width: 100%;
  }

  .iconSize {
    width: 189px;
    height: 189px;
  }
</style>
